import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { map, find } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
  Tabs,
  Tab,
  Modal
} from '@material-ui/core';
import { Add, MoreHoriz } from '@material-ui/icons';
import CourseModal from './components/AddCourse';
import { PaperHeader, HeaderTable } from '../../app/components';

import {
  fetchCourses,
  removeCourse,
  setCoursePage,
  setCoursePageCount,
} from './actions';
import {
  courseTitleChanged,
  courseSubjectChanged,
  courseNumberChanged,
  courseUniversityChanged,
  clearCourseFields,
} from './components/AddCourse/actions';
import {
  getCourses,
  getRequestedCourses,
  getCoursesWithTutors,
  fetchCoursesState,
  getPageInfo,
} from './selectors';
import { loadTexts } from '../../config/texts';

const tableHeaders = [
  { name: 'Course Name' },
  { name: 'Course Title' },
  { name: 'University' },
  { name: 'Credits' },
  { name: 'Available Tutors' },
  { name: 'Students' },
  { name: 'Tutor Rating' },

];

const isNumeric = [false, false, false, true, true, true, true];

const TEXT_KEY = 'courses';

class Courses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showOnlyAdded: false,
      showOnlyAvailable: false,
      searchText: '',
      data: [],
      openAdd: false,
      anchorEl: null,
      course: { _id: '' },
      mode: 'add',
      sort: null,
      selectedHeader: 0,
      texts: loadTexts(TEXT_KEY, props.locale),
      tutorModalOpen: false,
      selectedCourse: '',
    };

    this._onNextPage = this._onNextPage.bind(this);
    this._onPrevPage = this._onPrevPage.bind(this);
    this._onFetchCourses = this._onFetchCourses.bind(this);
    this._onOpenAdd = this._onOpenAdd.bind(this);
    this._onCloseAdd = this._onCloseAdd.bind(this);
    this._onSubmitCourse = this._onSubmitCourse.bind(this);
    this._onMoreActions = this._onMoreActions.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onOpenEditCourse = this._onOpenEditCourse.bind(this);
    this._onRemoveCourse = this._onRemoveCourse.bind(this);
    this._onShowOnlyAvailable = this._onShowOnlyAvailable.bind(this);
    this._onShowOnlyAdded = this._onShowOnlyAdded.bind(this);
    this._onSearchCourse = this._onSearchCourse.bind(this);
    this._onkeyPress = this._onkeyPress.bind(this);
    this._onSort = this._onSort.bind(this);
  }

  componentDidMount() {
    // const { listRange: { start, end }, courses } = this.props;
    // if (_.isEmpty(courses)) this._onFetchCourses(start, end);
    this._onFetchCourses({
      universities: [this.props.selectedUniversity],
    });
  }

  async componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedUniversity !== this.props.selectedUniversity
      || nextProps.selectedOrganization !== this.props.selectedOrganization
    )
      this._onFetchCourses({ universities: [nextProps.selectedUniversity] });
  }

  _onkeyPress(ev) {
    if (ev.key === 'Enter') {
      this.props.setCoursePage(1);
      this._onFetchCourses({});
    }
  }

  _onShowOnlyAvailable(event) {
    this.setState({ showOnlyAvailable: event.target.checked });
  }

  _onShowOnlyAdded(event) {
    this.setState({ showOnlyAdded: event.target.checked }, () => {
      this._onFetchCourses({});
    });
  }

  async _onFetchCourses({ universities = [this.props.selectedUniversity] }) {
    const { page, limit } = this.props.pagination;
    const { searchText, sort, showOnlyAdded } = this.state;
    await this.props.fetchCourses({
      filter: {
        universities,
        searchString: searchText,
        approved: showOnlyAdded,
      },
      page: { page, limit },
      sort,
    });
    this.props.setCoursePageCount(this.props.courses.length);
  }

  _onNextPage() {
    this.props.setCoursePage(this.props.pagination.page + 1);
    setTimeout(() => this._onFetchCourses({}), 0);
  }

  _onPrevPage() {
    this.props.setCoursePage(this.props.pagination.page - 1);
    setTimeout(() => this._onFetchCourses({}), 0);
  }

  _onOpenAdd() {
    this.setState({ openAdd: true, mode: 'add' }, () => {
      this.props.courseUniversityChanged(this.props.selectedUniversity);
    });
  }

  _onCloseAdd() {
    this.setState({ openAdd: false, anchorEl: null }, () => {
      this.props.clearCourseFields();
    });
  }

  _onSubmitCourse() {
    this._onFetchCourses({});
    this.setState(
      { openAdd: false, anchorEl: null, course: { _id: '' } },
      () => this.props.clearCourseFields(),
    );
  }

  _onMoreActions(course) {
    return event => { this.setState({ anchorEl: event.currentTarget, course }); };
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  _onOpenEditCourse() {
    const { course: { _id } } = this.state;
    const { coursesData } = this.props;
    this.setState({ openAdd: true, mode: 'edit' });
    const { title, subject, number, university } = coursesData[_id];
    this.props.courseTitleChanged(title);
    this.props.courseSubjectChanged(subject);
    this.props.courseNumberChanged(number);
    this.props.courseUniversityChanged(university._id);
  }

  _onRemoveCourse() {
    const { course: { _id } } = this.state;
    this.props.removeCourse({ course: _id })
      .then(() => {
        this.setState({ anchorEl: null });
        this._onFetchCourses({});
      });
  }

  _onSearchCourse(event) {
    this.setState({ searchText: event.target.value });
  }

  _onSort({ field, direction }) {
    let sort;
    switch (field) {
      case 'code':
        sort = [{ field: 'subject', direction }, { field: 'number', direction }];
        break;
      case 'title':
        sort = [{ field: 'title', direction }];
        break;
      default:
        break;
    }
    this.setState({ sort }, () => this._onFetchCourses({}));
  }

  renderCheckbox(classes, checked, onChange, value, text) {
    return (
      <div className={classes.checkboxContainer}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          color="primary"
          value={value}
        />
        <Typography>
          {text}
        </Typography>
      </div>
    );
  }

  renderFilter() {
    const { classes } = this.props;
    const { searchText, showOnlyAvailable, showOnlyAdded, texts } = this.state;

    return (
      <div className={classes.filters}>
        <TextField
          id="search"
          label={texts.fields.search}
          value={searchText}
          type="search"
          className={classes.textField}
          margin="normal"
          onChange={this._onSearchCourse}
          onKeyPress={this._onkeyPress}
        />
        <div className={classes.checkboxes}>
          {this.renderCheckbox(
            classes,
            showOnlyAdded,
            this._onShowOnlyAdded,
            'showOnlyAdded',
            texts.fields.tutors_added
          )}
          {this.renderCheckbox(
            classes,
            showOnlyAvailable,
            this._onShowOnlyAvailable,
            'showOnlyAvailable',
            texts.fields.tutors_available
          )}
        </div>
      </div>
    );
  }

  renderHeader() {
    const { selectedHeader, texts: { header } } = this.state;
    const { classes } = this.props;

    return (
      <Tabs
        value={selectedHeader}
        onChange={(event, value) => {
          this.setState({ selectedHeader: value });
          // if (value === 0) this.setState({ selectedApplicants: [] });
          // else this.setState({ selectedStudents: [] });
        }}
        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
      >
        <Tab
          disableRipple
          label={<div className={classes.tabText}>{header.approved}</div>}
          classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
        />
        <Tab
          disableRipple
          label={<div className={classes.tabText}>{header.requested}</div>}
          classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
        />
      </Tabs>
    );
  }

  renderCourses() {
    const {
      fetchState: { loading },
      count,
      pagination: { start, end },
      courses,
      coursesWithTutors,
    } = this.props;
    const { showOnlyAvailable } = this.state;

    return (
      <HeaderTable
        label="courses"
        data={courses}
        paging
        start={start}
        end={end}
        count={count}
        onNext={this._onNextPage}
        onPrev={this._onPrevPage}
        Action={datum => (
          <IconButton onClick={this._onMoreActions(datum)}>
            <MoreHoriz />
          </IconButton>
        )}
        loading={loading}
        hover={false}
        onRowClick={course =>{
          this.setState({ selectedCourse: course._id }, () => {
            this.setState({ tutorModalOpen: true })
          })
          // if (course['available tutors'].charAt(0) !== '0') {
          //   this.setState({ selectedCourse: course._id }, () => {
          //     this.setState({ tutorModalOpen: true })
          //   })
          // }
         }}
        onSort={this._onSort}
        sortEnabled
        colored={showOnlyAvailable}
      />
    );
  }

  renderRequestedCourses() {
    const {
      fetchState: { loading },
      requestedCourses
    } = this.props;
    return (
      <HeaderTable
        label="requested_courses"
        data={this.props.requestedCourses}
        count={this.props.requestedCourses.length}
        loading={loading}
        hover={false}
        onRowClick={this.handleOpen}
        onSort={this._onSort}
        sortEnabled
      />
    )
  }

  renderTutorModal() {
    const { tutorModalOpen, selectedCourse } = this.state;
    const { coursesWithTutors, classes } = this.props;
    const tutorData = find(coursesWithTutors, course => course._id === selectedCourse);

    let availableTutors = [];
    let nonAvailableTutors = [];
    console.log('tuto', tutorData)

    if (tutorData) {
      availableTutors = map(tutorData.availableTutors, tutor => tutor.user);
      nonAvailableTutors = map(tutorData.nonAvailableTutors, tutor => tutor.user);
    };
    // result = result.concat(result).concat(result).concat(result).concat(result).concat(result).concat(result).concat(result).concat(result).concat(result);

    return (
      <Modal
        aria-labelledby="Tutor List"
        aria-describedby="List of tutors available"
        open={tutorModalOpen}
        onClose={() => this.setState({ tutorModalOpen: false })}
      >
        <Paper className={classes.tutorModal}>
          <PaperHeader text={'Available Tutors'} style={{ marginBottom: 10, fontSize: 20 }} />
          <div className={classes.tutorModalItem}>
            <HeaderTable
              label="tutors"
              data={tutorData ? availableTutors : []}
              hover={false}
            />
          </div>
          <PaperHeader text={'Unavailable Tutors'} style={{ marginBottom: 10, fontSize: 20 }} />
          <div className={classes.tutorModalItem}>
            <HeaderTable
              label="tutors"
              data={tutorData ? nonAvailableTutors : []}
              hover={false}
            />
          </div>
        </Paper>
      </Modal>
    )
  }

  render() {
    const { classes } = this.props;
    const { openAdd, anchorEl, course, mode, selectedHeader } = this.state;
    // console.log('page', this.props.pagination)
    return (
      <Paper className={classes.root}>
        {this.renderTutorModal()}
        {this.renderFilter()}
        <div className={classes.headerContainer}>
          {this.renderHeader()}
          <Button color="primary" variant="fab" mini onClick={this._onOpenAdd}>
            <Add />
          </Button>
        </div>
        {selectedHeader === 0 && this.renderCourses()}
        {selectedHeader === 1 && this.renderRequestedCourses()}
        <Modal
          open={false}
          headers={tableHeaders}
          data={this.state.data}
          isNumeric={isNumeric}
          onClose={this.handleClose}
        />
        <CourseModal
          open={openAdd}
          mode={mode}
          onClose={this._onCloseAdd}
          onSubmit={this._onSubmitCourse}
          course={course._id || ''}
        />
        <Menu
          id="course-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          <MenuItem onClick={this._onOpenEditCourse}>Edit</MenuItem>
          <MenuItem onClick={this._onRemoveCourse}>Delete</MenuItem>
        </Menu>
      </Paper>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  tutorModal: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 75,
    height: '80%',
    transform: 'translate(-50%, -50%)',
    overflow: 'scroll',
    padding: theme.spacing.unit,
  },
  tutorModalItem: {
    maxHeight: '40%',
    overflow: 'scroll',
  },
  headerCell: {
    fontSize: 15,
  },
  input: {
    margin: theme.spacing.unit,
  },
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
  },
  gridContainer: {
    padding: theme.spacing.unit,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkboxes: {
    marginTop: theme.spacing.unit,
  },
  tabsRoot: {
    marginBottom: theme.spacing.unit * 5,
    marginLeft: theme.spacing.unit * 4,
    width: '50%'
  },
  tabsIndicator: {
    backgroundColor: '#4153af',
  },
  tabText: {
    fontSize: 18,
    fontWeight: theme.typography.fontWeightBold,
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    marginRight: theme.spacing.unit * 4,
    '&:hover': {
      color: 'grey',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#4153af',
    },
    '&:focus': {
      color: '#4153af',
    },
  },
  tabSelected: {},
  headerContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    flexDirection: 'row',
    display: 'flex',
    paddingRight: 20,
  }
});

Courses.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchCourses: PropTypes.func.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  selectedOrganization: PropTypes.string.isRequired,
  universities: PropTypes.array.isRequired,
  fetchState: PropTypes.object.isRequired,
  courseTitleChanged: PropTypes.func.isRequired,
  courseSubjectChanged: PropTypes.func.isRequired,
  courseNumberChanged: PropTypes.func.isRequired,
  removeCourse: PropTypes.func.isRequired,
  courseUniversityChanged: PropTypes.func.isRequired,
  clearCourseFields: PropTypes.func.isRequired,
  courses: PropTypes.array.isRequired,
  coursesData: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  pagination: PropTypes.object.isRequired,
  setCoursePage: PropTypes.func.isRequired,
  setCoursePageCount: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  courses: getCourses(state),
  coursesWithTutors: getCoursesWithTutors(state),
  requestedCourses: getRequestedCourses(state),
  fetchState: fetchCoursesState(state),
  // listRange: getCoursesListRange(state),
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  universities: state.auth.data.user.universities,
  coursesData: state.courses.main.data,
  count: state.appState.count,
  pagination: getPageInfo(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchCourses: params => dispatch(fetchCourses(params)()),
  removeCourse: params => dispatch(removeCourse(params)()),
  courseTitleChanged: params => dispatch(courseTitleChanged(params)),
  courseSubjectChanged: params => dispatch(courseSubjectChanged(params)),
  courseNumberChanged: params => dispatch(courseNumberChanged(params)),
  courseUniversityChanged: params => dispatch(courseUniversityChanged(params)),
  clearCourseFields: params => dispatch(clearCourseFields(params)),
  setCoursePage: params => dispatch(setCoursePage(params)),
  setCoursePageCount: params => dispatch(setCoursePageCount(params)),
});

export default compose(
  withStyles(styles, { name: 'Courses' }),
  connect(mapStateToProps, mapDispatchToProps)
)(Courses);



// WEBPACK FOOTER //
// ./src/modules/courses/Scene.js